export class LoginWithFacebookModalActions {
    login: () => void;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details/login.with.facebook.modal/login.with.facebook.modal.actions.ts